export interface WeekFilterType {
  week: moment.Moment
}

export const initialWeekFilter: WeekFilterType = {
  week: undefined 
};
